import { Company } from "@/models/company";
import { TrustGroupType } from "@/models/enum/trustGroupType";

export class TrustGroup {
  id: string = "";
  companyId: string = "";
  company: Company = new Company();
  userProfileEmails: string[] = [];
  isCustomer: boolean = false;
  trustGroupType: TrustGroupType = TrustGroupType.Channel2Customer;
}
